document.addEventListener("zrx-loaded", function (e) {
  let prices = document.querySelectorAll('.zrx-frequently-bought-together .money');
  prices.forEach((p) => {
    p.textContent = p.textContent.replace('.', ',')
                 
  })
});